package fr.arcplex.network

import fr.arcplex.network.AuthProvider
import fr.arcplex.network.NetworkConfig
import fr.arcplex.network.SoonerApi
import fr.arcplex.network.impl.coherence.CoherenceSoonerApi
import fr.arcplex.network.impl.legacy.LegacySoonerApi
import fr.arcplex.network.reporting.EventQueue
import fr.arcplex.network.reporting.LegacyEventTransport
import fr.arcplex.network.reporting.Reporter

/**
 * Factory behind the single backend choice: legacy or Coherence (with legacy
 * fallback), both driven through the [SoonerApi] port.
 */
object SoonerApiFactory {

    fun create(config: NetworkConfig, auth: AuthProvider): SoonerApi {
        val legacy = LegacySoonerApi(
            config.legacyBaseUrl,
            auth,
            allowInvalidCertificates = config.allowInvalidCertificates
        )
        return if (config.useCoherence) {
            CoherenceSoonerApi(legacy, config)
        } else {
            legacy
        }
    }

    /**
     * Reporting endpoint of the current backend. The transport and its base URL
     * stay in this module so the UI only calls `report`.
     */
    fun createReporter(config: NetworkConfig, auth: AuthProvider): Reporter =
        Reporter(
            queue = EventQueue(),
            transport = LegacyEventTransport(
                baseUrl = config.legacyBaseUrl,
                userToken = { auth.getUserToken() },
                allowInvalidCertificates = config.allowInvalidCertificates
            )
        )
}
